import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import { colors } from '@sweep-io/sweep-design';

export const QuickSearchLightboxItemSkeleton = () => {
  return (
    <Stack spacing={2} direction="row" height="64px" alignItems="center" pl={1.5} pr={1.5}>
      <Skeleton
        variant="rounded"
        width={12}
        height={12}
        sx={{ borderRadius: '100px', backgroundColor: colors.grey[120] }}
      />
      <Stack direction="column" gap={1.5}>
        <Skeleton
          variant="rounded"
          width={140}
          height={8}
          sx={{ backgroundColor: colors.grey[120] }}
        />
        <Skeleton
          variant="rounded"
          animation="wave"
          width={250}
          height={8}
          sx={{ backgroundColor: colors.grey[120] }}
        />
      </Stack>
    </Stack>
  );
};
